import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import cloudinary from "cloudinary";
import cloudinaryConfig from "../../config/cloudinaryConfig";

const CloudinaryMediaLibrary = ({
  value,
  children,
  onChange,
  multiple,
  preview,
  id,
}) => {
  const email = useSelector((store) => store.firebase.profile.email);

  const openMediaLibrary = () =>
    cloudinary.openMediaLibrary(
      {
        username: email,
        ...cloudinaryConfig,
        multiple: multiple,
      },
      {
        insertHandler: (data) => {
          let images = [];  
          data.assets.forEach((asset) => {
            images.push(asset.public_id);
          });
          if (multiple) {
            onChange(images);
          } else {
            onChange(images[0]);
          }
        },
      }
    );

  const previewImages = () => {
    if (value.length !== 0) {
      return (
        <>
          {value.map((imageId, i) => (
            <img
              key={`${id}-preview-${i}`}
              src={`https://res.cloudinary.com/rauru/image/upload/c_thumb,h_100/v1601074827/${imageId}`}
              alt={`${id}-preview-${i}`}
            />
          ))}
          <br />
        </>
      );
    }
    return;
  };

  return (
    <>
      {preview && multiple && previewImages()}
      {preview && !multiple && value !== "" &&  value !== null &&(
        <img key={`${id}-preview`} src={`https://res.cloudinary.com/rauru/image/upload/c_thumb,h_100/v1601074827/${value}`} alt={`${id}-preview`} />
      )}
      <span className="btn" onClick={openMediaLibrary}>
        {children}
      </span>
    </>
  );
};

CloudinaryMediaLibrary.defaultProps = {
  children: "Upload Files",
  multiple: false,
  preview: false,
};

CloudinaryMediaLibrary.prototypes = {
  id: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  preview: PropTypes.bool,
};

export default CloudinaryMediaLibrary;
